export function inputRadioStyle() {
  const radioContainer = document.querySelectorAll('.js-form-radio-container');
  if(radioContainer.length) {
    radioContainer.forEach(function(el) {
      const radios = el.querySelectorAll('.form-radio-view');
      const select = el.querySelector('select');
      if(radios.length) {
        radios.forEach(function(_el) {
          const dataOrder = _el.getAttribute('data-radio-order');
          const dataValue = _el.getAttribute('data-radio-value');
          _el.addEventListener('click', (e) => {
            e.preventDefault();
            radios.forEach(function(__el) {
              __el.classList.remove('is-selected')
            })
            _el.classList.add('is-selected');
            select.options[dataOrder].selected = true;
          })
          if(select.value !== '' && select.value == dataValue) {
            _el.classList.add('is-selected');
          }
        });
      }
    });
  }
}